import { inject, Injectable } from '@angular/core';
import { BaseFilterCompanySegment } from '@clean-code/models';
import { ConfigService } from '@clean-code/shared/util-config';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseFilterService {
  private graphqlService = inject(GraphqlService);
  private configService = inject(ConfigService);

  public get$(): Observable<BaseFilterCompanySegment[]> {
    const query = `
      query GetCompanyType {
          companyTypesGetAll {
            id
            name
            option
          }
        }
    `;
    return this.graphqlService.query<BaseFilterCompanySegment[]>(
      query,
    );
  }
}
